var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("form-item", {
        attrs: {
          "class-name": _vm.hasTemplateReplacementCharactersSubject
            ? "is-invalid-input"
            : "",
          "data-test": "message-subject",
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _vm._v("\n      件名"),
                _c("br"),
                _vm._v(" "),
                _c("small", [_vm._v("（250文字以内）")]),
              ]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [
                _vm.hasTemplateReplacementCharactersSubject
                  ? _c("validation-label", {
                      attrs: {
                        label: _vm.templateValidationMessage,
                        "data-test":
                          "has-template-replacement-characters-subject",
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.message.subject,
          callback: function ($$v) {
            _vm.$set(_vm.message, "subject", $$v)
          },
          expression: "message.subject",
        },
      }),
      _vm._v(" "),
      _c("form-item-text-area", {
        ref: "message",
        attrs: {
          "class-name": _vm.hasTemplateReplacementCharactersBody
            ? "boss-send-textarea is-invalid-input"
            : "boss-send-textarea",
          rows: "",
          cols: "",
          "data-test": "message-body",
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "boss-textarea-button margin-bottom-1" },
                  [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content:
                                "本文にカーソルを合わせてクリックすると、■USER_ID■ 様 と挿入されます。メッセージ送信時に自動的に会員IDに変換されます。",
                            },
                            expression:
                              "{ content: '本文にカーソルを合わせてクリックすると、■USER_ID■ 様 と挿入されます。メッセージ送信時に自動的に会員IDに変換されます。'}",
                          },
                        ],
                        staticClass: "boss-button",
                        attrs: {
                          type: "button",
                          "data-test": "insertion-user-id",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.insertionValue(_vm.userIdInsertText)
                          },
                        },
                      },
                      [_vm._v("\n          会員IDを挿入\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content:
                                "本文にカーソルを合わせてクリックすると、社名が挿入されます。",
                            },
                            expression:
                              "{ content: '本文にカーソルを合わせてクリックすると、社名が挿入されます。'}",
                          },
                        ],
                        staticClass: "boss-button",
                        attrs: {
                          type: "button",
                          "data-test": "insertion-company-name",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.insertionValue(
                              _vm.currentUser.companyUserDisplayName
                            )
                          },
                        },
                      },
                      [_vm._v("\n          社名を挿入\n        ")]
                    ),
                    _vm._v("\n        （本文にのみ有効）\n      "),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "label",
            fn: function () {
              return [
                _vm._v("\n      本文"),
                _c("br"),
                _vm._v(" "),
                _c("small", [_vm._v("（10,000文字以内）")]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [
                _vm.hasTemplateReplacementCharactersBody
                  ? _c("validation-label", {
                      attrs: {
                        label: _vm.templateValidationMessage,
                        "data-test": "has-template-replacement-characters-body",
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.message.body,
          callback: function ($$v) {
            _vm.$set(_vm.message, "body", $$v)
          },
          expression: "message.body",
        },
      }),
      _vm._v(" "),
      _c("form-item-group", {
        attrs: {
          label: "スカウト特典（任意）",
          options: _vm.specialFavors,
          "label-class-name": "boss-scout-bonus pega-mr-5 pega-input",
          "class-name": "boss-bonus-check",
          "value-class-name": "boss-bonus-check-text boss-bonus-check-mark",
        },
        model: {
          value: _vm.message.specialFavorIds,
          callback: function ($$v) {
            _vm.$set(_vm.message, "specialFavorIds", $$v)
          },
          expression: "message.specialFavorIds",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }